import { useMutation } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { FileController } from 'src/controllers/file.controller'
import { FileDto } from 'src/dto/file.dto'

const fileController = new FileController()

export function useUploadFile(entity: string, referenceId?: string) {
  const { userFarm: farmId } = useAuth()

  return useMutation<FileDto, Error, File>({
    mutationKey: ['uploadFile', entity, referenceId],
    mutationFn: (file: File) => fileController.uploadFile(farmId!, entity, referenceId!, file)
  })
}
